import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import "../../../../config/i18n";
import { withTranslation } from "react-i18next";

const config = {
	apiKey: 'AIzaSyA5h0ra_DpRn2ii7bN0kQb0yFfmZgQg-XE',
	authDomain: 'neat-talent-402217.firebaseapp.com',
};

if (!firebase.apps.length) {
	firebase.initializeApp(config);
}

const uiConfig = {
	signInFlow: 'popup',
    signInOptions: [
    	firebase.auth.PhoneAuthProvider.PROVIDER_ID,
    ],
	callbacks: {
		signInSuccessWithAuthResult: function(authResult, redirectUrl) {
			var phone_no = authResult['user']['phoneNumber'];
			const cookies = new Cookies();
			var hosturl = window.location.href;
			var api_url = localStorage.getItem('api_url');

			var signin = new FormData();
			signin.set('phone', phone_no);
			signin.set('fcmtoken', cookies.get('mytoken'));
			axios({
				method: 'post',
				url: api_url+'webcheckphone',
				data: signin,
				config: { headers: {'Content-Type': 'multipart/form-data' }}
			}).then(res => {
				if(res.data.status !== "false"){
					var editprofile = new FormData();
					editprofile.set('phone', phone_no);
					editprofile.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
				    axios({
						method: 'post',
						url: api_url+'websetprofile',
						data: editprofile,
						config: { headers: {'Content-Type': 'multipart/form-data' }}
					}).then(res => {
						alert('Successfully updated');
						hosturl = hosturl.replace('Editphonefirebase','');
		                window.location.href = hosturl+"profile";
						// window.location.href = "/profile";
				    });
				} else {
					alert('Sorry, You are already registered this Mobile Number');
					hosturl = hosturl.replace('Editphonefirebase','');
					window.location.href = hosturl+"profile";
					// window.location.href = "/profile";
				}
			});
		}	
    }
};

class Editphonefirebase extends Component {
    constructor(props) {
    	super(props);
    	this.state = {
            api_url: localStorage.getItem('api_url'),
        };
    }

	componentDidMount() {
		if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
			document.body.dir = 'rtl';
			document.body.classList.add('rtl');
			document.body.classList.remove('ltr')
		} else {
			document.body.dir = 'ltr';
			document.body.classList.remove('rtl');
			document.body.classList.add('ltr');
		}
	}

    render() {
        return (
            <div className="welcomePage">
                <div className="welcomePageCenterContent">
                    <div className="welcomeLogo"></div>
					<div className="w-100">
 						<StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
					</div>
                </div>
            </div>
        );
    }
}

export default withTranslation("translations")(withRouter(Editphonefirebase));